// This snippet formats the ID of a component for Cypress testing.
// It does that by removing all non-alphanumeric characters from the ID.

export const formatCypressID = (id: string): string =>
  id.toLowerCase().replace(/[^a-z0-9]/g, '');
